import { ICustomButton } from "../interfaces/custom-button.interface"

export const CustomSVGButton = ({ hasIcon, text, icon, btnType, btnSeverity, hasText, className, style, onClick }: ICustomButton) => {
    return (
        <button onClick={onClick} style={style} className={`${className } `}>
            {hasIcon && icon} {hasIcon ? '  ' : ''} {hasText && text}
        </button>
    )
}